import React, { Component } from "react";
import PropTypes from "prop-types";

import i18n from "i18n-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { APIHandler } from "C4";
import { name } from "settings";

export default class Diploma extends Component {
  constructor(props) {
    super(props);

    this.state = {
      diplomaLoaded: false,
    };
  }

  componentDidMount() {
    // this.graduateUser();
  }

  toggle(diplomaLoaded) {
    this.setState({ diplomaLoaded });
  }

  // Extra graduation call to be sure
  graduateUser() {
    const d = new Date(Date.now());
    const leading = (val) => `0${val}`.slice(-2);
    const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(
      d.getDate()
    )}`;
    const { email, appId } = this.props;
    APIHandler.updateUser(appId, email, [
      { param: "sales_companion_registered", val: date },
      { param: "training_started", val: date },
      { param: "training_graduated", val: date },
    ]).then((res) => {});
  }

  render() {
    const { appId, firstName, lastName, email, type } = this.props;

    const image = `https://cms.travpromobile.com/api/app/diploma?first_name=${firstName}&last_name=${lastName}&app_id=${appId}&email=${email}`;

    const subject = encodeURIComponent(`${name} diploma`);
    const body = encodeURIComponent(image);

    return (
      <div
        style={{ display: "none" }}
        id="diploma"
        className="fancybox-share diploma"
      >
        <img
          className="diploma__image"
          name="diploma"
          src={image}
          alt="diploma"
        />
        <div className="buttons__diploma">
          <a
            href={`/print/${encodeURIComponent(firstName)}/${encodeURIComponent(
              lastName
            )}/${appId}`}
            disabled={!this.state.diplomaLoaded}
            className="fancybox-share__button fancybox-share__button--fb"
          >
            <FontAwesomeIcon icon={["fas", "print"]} />
            {i18n.translate("reportCard.print")}
          </a>
          <a
            href={`mailto:?subject=${subject}&body=${body}`}
            className="fancybox-share__button fancybox-share__button--pt"
          >
            <FontAwesomeIcon icon={["fas", "at"]} />
            <span>{i18n.translate("reportCard.email")}</span>
          </a>
          <a
            href={APIHandler.getDownloadURL(
              image,
              `${name} Diploma ${firstName} ${lastName}.png`
            )}
            download={`${subject}.png`}
            className="fancybox-download__button fancybox-download__button--pt"
          >
            <FontAwesomeIcon icon={["fas", "download"]} />
            <span>{i18n.translate("reportCard.download")}</span>
          </a>
        </div>
      </div>
    );
  }
}

Diploma.propTypes = {
  appId: PropTypes.number,
  email: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  chapterId: PropTypes.number,
  type: PropTypes.string,
};

Diploma.defaultProps = {
  appId: -1,
  chapterId: 0,
  email: "",
  firstName: "",
  lastName: "",
  type: "app",
};
